import { NgModule } from "@angular/core";
import { ColorPickerComponent } from "./color-picker.component";

@NgModule({
  declarations: [ ColorPickerComponent ],
  exports: [ ColorPickerComponent ]
})
export class PlColorPickerModule { }
